import { createApp } from 'vue'
import App from './App.vue';
import { store } from './store.js';
import { versionNumber } from './myapp/src/core/environment';
import { lang } from './myapp/src/lang.js';
import { launchPhaser } from './myapp/src/core/game.js';
import { db } from './myapp/src/core/db';
import { cameras } from './myapp/src/view/cameras';

// Put version number in console
console.info('version ' + versionNumber);


// Launch Vue
const app = createApp(App);
app.use(store).mount('#app');

/**
 * After document has loaded:
 *  - launch database
 *  - launch phaser app
 *  - add trix to the DOM
 *  - translate app
*/

window.addEventListener('load', () => {
    db.launchDB();
    launchPhaser();

    // add Trix to document (add after Vue loads so Vue doesn't try to parse it and complain)
    const x = document.createElement('trix-editor');
    document.getElementById('trix-holder').appendChild(x);

    const y = document.createElement('trix-editor');
    document.getElementById('export-trix-holder').appendChild(y);

    cameras.initializePinch();

    // now translate (requires trix to exist)
    lang.translateApp();
});

window.addEventListener('unhandledrejection', err => {
    console.warn(`Unhandled rejection: ${err.reason}`);
});

// track whether mouse button is down or not

b3.primaryMouseButtonDown = false;
const setPrimaryButtonState = evt => {
    const flags = evt.buttons ?? evt.which;
    if (typeof flags !== 'number') return;
    b3.primaryMouseButtonDown = (flags & 1) === 1;
};
window.addEventListener('mousedown', setPrimaryButtonState);
window.addEventListener('mousemove', setPrimaryButtonState);
window.addEventListener('mouseup', setPrimaryButtonState);